"use client";
import React from 'react';
import { Input, Label } from '@develos/next-components';
import { useTranslations } from '@develos/next-library';
import { FromToFilterType } from '@/types';

type Props = {
    value?: FromToFilterType<number>,
    handleChange: (date: FromToFilterType<number>) => void
}

const NumericFromToFilter = ({ handleChange, value}: Props) => {
    const { translate } = useTranslations();
    
    const getNumValue = (value: string, currentValue?: number): number | undefined => {
        const parsedValue = parseInt(value);
        if(!isNaN(parsedValue)) {
            return parsedValue;
        } else if(value !== ""){
            return currentValue;
        }
        return undefined;
    }
    
    return (
        <div className='rm-flex rm-gap-2'>
            <div className='rm-flex rm-gap-2 rm-items-center'>
                <Label>
                    {translate('Od')}
                </Label>
                <Input.Text
                    handleChange={(e, val) => handleChange({to: value?.to, from: getNumValue(val!, value?.from)})}
                    value={value?.from?.toString() ?? ""}
                />
            </div>
            <div className='rm-flex rm-gap-2 rm-items-center'>
                <Label>
                    {translate('Do')}
                </Label>
                <Input.Text
                    handleChange={(e, val) => handleChange({from: value?.from, to: getNumValue(val!, value?.to)})}
                    value={value?.to?.toString() ?? ""}
                />
            </div>
        </div>
    );
};

export default NumericFromToFilter;